import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addBlogAPI,
  addBlogImgAPI,
  addEmailTemplateAPI,
  addSMSTemplateAPI,
  addSendSMSAPI,
  addSendWhatsappAPI,
  addSendeMailAPI,
  deleteBlogAPI,
  deleteEmailTemplateAPI,
  deleteSMSTemplateAPI,
  getAllTemplatePlaceholdersApi,
  getAllUsersAPI,
  getBlogAPI,
  getEmailTemplateAPI,
  getSMSTemplateAPI,
  getSingleBlogAPI,
  getUsersAPI,
  receiveEmailAPI,
  updateBlogAPI,
  updateEmailTemplateAPI,
  updateSMSTemplateAPI,
} from "../../api/common/MarketingApi";

const initialState = {
  placeholders: [],
  emailTemplates: [],
  emailTemplate: {},

  smsTemplates: [],
  smsTemplate: {},

  users: [],
  user: {},
  selectedUsers: [],

  blogs: [],
  blog: {},
  blogImg: null,

  userCourse: [],

  loading: false,
  addnUpSmsLoading: null,
  addnUpEmailLoading: false,
  addnUpBlogLoading: true,
  sendLoading: false,
};

export const getEmailTemplate = createAsyncThunk(
  "marketing/getEmailTemplate",
  async (payload, {rejectWithValue}) => {
    try {
      const response = await getEmailTemplateAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const addEmailTemplate = createAsyncThunk(
  "marketing/addEmailTemplate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await addEmailTemplateAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const updateEmailTemplate = createAsyncThunk(
  "marketing/updateEmailTemplate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateEmailTemplateAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const deleteEmailTemplate = createAsyncThunk(
  "marketing/deleteEmailTemplate",
  async (id, { rejectWithValue }) => {
    try {
      const response = await deleteEmailTemplateAPI(id);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const getSMSTemplate = createAsyncThunk(
  "marketing/getSMSTemplate",
  async (rejectWithValue) => {
    try {
      const response = await getSMSTemplateAPI();
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const addSMSTemplate = createAsyncThunk(
  "marketing/addSMSTemplate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await addSMSTemplateAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const updateSMSTemplate = createAsyncThunk(
  "marketing/updateSMSTemplate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateSMSTemplateAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const deleteSMSTemplate = createAsyncThunk(
  "marketing/deleteSMSTemplate",
  async (id, { rejectWithValue }) => {
    try {
      const response = await deleteSMSTemplateAPI(id);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const addSendeMail = createAsyncThunk(
  "marketing/addSendeMail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await addSendeMailAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const addSendSMS = createAsyncThunk(
  "marketing/addSendSMS",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await addSendSMSAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const addSendWhatsapp = createAsyncThunk(
  "marketing/addSendWhatsapp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await addSendWhatsappAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const receiveEmail = createAsyncThunk(
  "marketing/receiveEmail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await receiveEmailAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const getUsers = createAsyncThunk(
  "marketing/getUsers",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getUsersAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const getAllUsers = createAsyncThunk(
  "marketing/getAllUsers",
  async (payload,{rejectWithValue}) => {
    try {
      const response = await getAllUsersAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const getBlog = createAsyncThunk(
  "blog/getBlog",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getBlogAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const getSingleBlog = createAsyncThunk(
  "blog/getSingleBlog",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getSingleBlogAPI(payload);
      return response?.data?.response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const addBlog = createAsyncThunk(
  "marketing/addBlog",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await addBlogAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const updateBlog = createAsyncThunk(
  "marketing/updateBlog",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateBlogAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const deleteBlog = createAsyncThunk(
  "marketing/deleteBlog",
  async (id, { rejectWithValue }) => {
    try {
      const response = await deleteBlogAPI(id);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const addBlogImg = createAsyncThunk(
  "marketing/addBlogImg",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await addBlogImgAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const getAllTemplatePlaceholders = createAsyncThunk(
  "marketing/getAllTemplatePlaceholders",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getAllTemplatePlaceholdersApi();
      console.log("payload in getAllOfferLetterTemplates", response?.data);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
)

const marketingSlice = createSlice({
  name: "marketing",
  initialState,
  reducers: {
    setSelectedUsers: (state, action) => {
      const selectedUsers = action.payload?.filter((user) => user.isChecked) || [];
      state.selectedUsers = selectedUsers;

      if (Array.isArray(state.users)) {
        state.users = action.payload || [];
        return;
      }

      if (state.users && typeof state.users === "object") {
        state.users = {
          ...state.users,
          content: action.payload || [],
        };
        return;
      }

      state.users = {
        content: action.payload || [],
      };
    },
    setEmailTemplateData: (state, action) => {
      state.emailTemplate = action.payload;
    },
    setSmsTemplateData: (state, action) => {
      state.smsTemplate = action.payload;
    }
  },
  extraReducers: (builder) => {
    //GET emailTemplates
    builder.addCase(getEmailTemplate.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEmailTemplate.fulfilled, (state, action) => {
      state.emailTemplates = action.payload?.response;
      state.loading = false;
    });
    builder.addCase(getEmailTemplate.rejected, (state) => {
      state.loading = true;
    });

    //add emailTemplates
    builder.addCase(addEmailTemplate.pending, (state) => {
      state.addnUpEmailLoading = true;
    });
    builder.addCase(addEmailTemplate.fulfilled, (state, action) => {
      state.emailTemplate = action.payload.response;
      state.emailTemplates
        ? state.emailTemplates.push(action.payload.response)
        : (state.emailTemplates = [action.payload.response]);
      state.addnUpEmailLoading = false;
    });
    builder.addCase(addEmailTemplate.rejected, (state) => {
      state.addnUpEmailLoading = false;
    });

    //update emailTemplates
    builder.addCase(updateEmailTemplate.pending, (state) => {
      state.addnUpEmailLoading = true;
    });
    builder.addCase(updateEmailTemplate.fulfilled, (state, action) => {
      // state.emailTemplate = action.payload.response;
      // const { arg } = action.meta;
      // if (arg) {
      //   state.emailTemplates = state.emailTemplates.map((item) =>
      //     item.emailTemplateId === arg.emailTemplateId
      //       ? {
      //         emailTemplateId: arg.emailTemplateId,
      //         subject: arg.subject,
      //         emailBody: arg.emailBody,
      //       }
      //       : item
      //   );
      // }
      state.addnUpEmailLoading = false;
    });
    builder.addCase(updateEmailTemplate.rejected, (state) => {
      state.addnUpEmailLoading = false;
    });

    //delete emailTemplates
    builder.addCase(deleteEmailTemplate.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteEmailTemplate.fulfilled, (state, action) => {
      // state.emailTemplate = action.payload;
      const { arg } = action.meta;
      if (arg) {
        state.emailTemplates = state.emailTemplates.filter(
          (item) => item.emailTemplateId !== arg
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteEmailTemplate.rejected, (state) => {
      state.loading = false;
    });

    //GET smsTemplates
    builder.addCase(getSMSTemplate.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSMSTemplate.fulfilled, (state, action) => {
      state.smsTemplates = action.payload?.response;
      state.loading = false;
    });
    builder.addCase(getSMSTemplate.rejected, (state) => {
      state.loading = true;
    });

    //add smsTemplates
    builder.addCase(addSMSTemplate.pending, (state) => {
      state.addnUpSmsLoading = false;
    });
    builder.addCase(addSMSTemplate.fulfilled, (state, action) => {
      state.smsTemplate = action.payload?.response;
      state.smsTemplates
        ? state.smsTemplates.push(action.payload.response)
        : (state.smsTemplates = [action.payload.response]);
      state.addnUpSmsLoading = true;
    });
    builder.addCase(addSMSTemplate.rejected, (state) => {
      state.addnUpSmsLoading = null;
    });

    //update smsTemplates
    builder.addCase(updateSMSTemplate.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateSMSTemplate.fulfilled, (state, action) => {
      state.smsTemplate = action.payload.response;
      const { arg } = action.meta;
      if (arg) {
        state.smsTemplates = state.smsTemplates.map((item) =>
          item.smsTemplateId === arg.smsTemplateId
            ? {
              smsTemplateId: arg.smsTemplateId,
              message: arg.message,
            }
            : item
        );
      }
      state.loading = false;
    });
    builder.addCase(updateSMSTemplate.rejected, (state) => {
      state.loading = true;
    });

    //delete smsTemplates
    builder.addCase(deleteSMSTemplate.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteSMSTemplate.fulfilled, (state, action) => {
      state.smsTemplate = action.payload;
      const { arg } = action.meta;
      if (arg) {
        state.smsTemplates = state.smsTemplates.filter(
          (item) => item.smsTemplateId !== arg
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteSMSTemplate.rejected, (state) => {
      state.loading = true;
    });

    //add addSendeMail
    builder.addCase(addSendeMail.pending, (state) => {
      state.sendLoading = true;
    });
    builder.addCase(addSendeMail.fulfilled, (state, action) => {
      state.sendLoading = false;
    });
    builder.addCase(addSendeMail.rejected, (state) => {
      state.sendLoading = false;
    });

    //add addSendSMS
    builder.addCase(addSendSMS.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addSendSMS.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(addSendSMS.rejected, (state) => {
      state.loading = true;
    });

    //add addSendWhatsapp
    builder.addCase(addSendWhatsapp.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addSendWhatsapp.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(addSendWhatsapp.rejected, (state) => {
      state.loading = true;
    });

    //add receiveEmail
    builder.addCase(receiveEmail.pending, (state) => {
      state.sendLoading = true;
    });
    builder.addCase(receiveEmail.fulfilled, (state) => {
      state.sendLoading = false;
    });
    builder.addCase(receiveEmail.rejected, (state) => {
      state.sendLoading = false;
    });

    //GET users
    builder.addCase(getUsers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.users = action.payload?.response;
      state.loading = false;
    });
    builder.addCase(getUsers.rejected, (state) => {
      state.loading = true;
    });

    //GET all users
    builder.addCase(getAllUsers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllUsers.fulfilled, (state, action) => {
      state.users = action.payload?.response;
      state.loading = false;
    });
    builder.addCase(getAllUsers.rejected, (state) => {
      state.loading = true;
    });


    //GET blog
    builder.addCase(getBlog.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBlog.fulfilled, (state, action) => {
      state.blogs = action.payload?.response;
      state.loading = false;
    });
    builder.addCase(getBlog.rejected, (state) => {
      state.loading = true;
    });

    //GET blog
    builder.addCase(getSingleBlog.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleBlog.fulfilled, (state, action) => {
      state.blog = action.payload?.currentBlog;
      state.loading = false;
    });
    builder.addCase(getSingleBlog.rejected, (state) => {
      state.loading = true;
    });

    //add blog
    builder.addCase(addBlog.pending, (state) => {
      state.addnUpBlogLoading = false;
    });
    builder.addCase(addBlog.fulfilled, (state, action) => {
      state.blog = action.payload?.response;
      state.blogs.blog
        ? state.blogs.blog.push(action.payload.response)
        : (state.blogs.blog = [action.payload.response]);
      state.addnUpBlogLoading = true;
    });
    builder.addCase(addBlog.rejected, (state) => {
      state.addnUpBlogLoading = true
    });

    //update blog
    builder.addCase(updateBlog.pending, (state) => {
      state.loading = true;
      state.addnUpBlogLoading = false;
    });
    builder.addCase(updateBlog.fulfilled, (state, action) => {
      state.blog = action.payload.response;
      const { arg } = action.meta;
      if (arg) {
        state.blogs = {
          currentPage: state.blogs.currentPage,
          totalItems: state.blogs.totalItems,
          totalPages: state.blogs.totalPages,
          blog: state.blogs.blog.map((item) =>
            Number(item.blogId) === Number(arg.blogId)
              ? {
                blogUrl: arg.blogUrl,
                blogDescription: arg.blogDescription
                  ? arg.blogDescription
                  : "",
                blogId: arg.blogId,
                blogTitle: arg.blogTitle,
                featuredImage: arg.featuredImage,
                thumbnailImage: arg.thumbnailImage,
                metaDescription: arg.metaDescription,
                metaKeyWord: arg.metaKeyWord,
                blogTags: arg.blogTags,
              }
              : item
          ),
        };
      }
      state.loading = false;
      state.addnUpBlogLoading = true;
    });
    builder.addCase(updateBlog.rejected, (state) => {
      state.loading = true;
      state.addnUpBlogLoading = false;
    });

    //delete blog
    builder.addCase(deleteBlog.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteBlog.fulfilled, (state, action) => {
      state.blog = action.payload;
      const { arg } = action.meta;
      if (arg) {
        state.blogs.blog = state.blogs.blog.filter(
          (item) => item.blogId !== arg
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteBlog.rejected, (state) => {
      state.loading = true;
    });

    //add blog img
    builder.addCase(addBlogImg.pending, (state) => {
      state.blogImg = true;
    });
    builder.addCase(addBlogImg.fulfilled, (state, action) => {
      state.blogImg = action.payload?.response;
      state.addnUpBlogLoading = false;
    });
    builder.addCase(addBlogImg.rejected, (state) => {
      state.blogImg = null;
    });

    // get All Offer LetterTemplate Placeholders
    builder.addCase(getAllTemplatePlaceholders.pending, (state)=>{
      state.loading = true;
    });
    builder.addCase(getAllTemplatePlaceholders.fulfilled, (state, action)=>{
      state.placeholders = action?.payload?.response;
      state.loading = false;
    });
    builder.addCase(getAllTemplatePlaceholders.rejected, (state)=>{
      state.loading = false;
    });
  },
});

export const { setSelectedUsers, setEmailTemplateData, setSmsTemplateData} = marketingSlice.actions;
export default marketingSlice.reducer;
